// @flow

export type BoxOutput = {
  [output: string]: ?number
};

export type Output = {
  [part: string]: ?number
}

const box15Outputs: BoxOutput = {
  '0': null,
  '4': 215,
  '12': 315,
  '20': 415,
  '28': 515,
  '36': 615,
  '44': 715,
  '52': 815,
  '60': 915
};

const box25Outputs: BoxOutput = {
  '0': null,
  '8': 225,
  '16': 325,
  '24': 425,
  '32': 525,
  '40': 625,
  '48': 725,
  '56': 825,
  '64': 925
};

const thermalOutputs: Output = {
  '215': 3,
  '225': 7,
  '315': 11,
  '325': 15,
  '415': 19,
  '425': 23,
  '515': 27,
  '525': 31,
  '615': 35,
  '625': 39,
  '715': 43,
  '725': 47,
  '815': 51,
  '825': 55,
  '915': 59,
  '925': 63
};

const mechanicalOutputs: Output = {
  '215': 2,
  '225': 6,
  '315': 10,
  '325': 14,
  '415': 18,
  '425': 22,
  '515': 26,
  '525': 30,
  '615': 34,
  '625': 38,
  '715': 42,
  '725': 46,
  '815': 50,
  '825': 54,
  '915': 58,
  '925': 62
};

export {
  box15Outputs,
  box25Outputs,
  mechanicalOutputs,
  thermalOutputs
};



// WEBPACK FOOTER //
// ./src/utils/vortex/outputs.js